{"brand":{"circular":true,"logoUrl":"https://github.com/jamesbhobbs.png","primaryColor":"#6366F1","secondaryColor":"#A78BFA"}}